import { TEAM, IMAGES } from "../constants/config";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";

function TeamMemberCard({ member, index }) {
  return (
    <StaggerItem index={index}>
      <article className="hover-lift group flex h-full flex-col overflow-hidden rounded-xl border-2 border-gray-200 bg-white shadow-md hover:border-[#5d69be]/30">
        <div className="hover-zoom relative aspect-[4/5] w-full bg-indigo-50">
          <img
            loading="lazy"
            src={member.image}
            alt={member.name}
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-indigo-950/90 via-indigo-950/50 to-transparent px-4 pb-4 pt-16">
            <h3 className="text-lg font-bold leading-snug text-white md:text-xl">
              {member.name}
            </h3>
            <span className="mt-2 inline-block rounded-full border border-indigo-300 bg-indigo-800/80 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-indigo-100">
              {member.role}
            </span>
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-4 p-4 md:p-5">
          <blockquote className="flex items-start gap-2">
            <span
              className="mt-0.5 flex-shrink-0 text-2xl leading-none text-indigo-600"
              aria-hidden="true"
            >
              "
            </span>
            <p className="text-sm font-medium leading-relaxed text-gray-600 md:text-base">
              {member.quote}
            </p>
          </blockquote>

          <div className="mt-auto flex items-center gap-3 border-t border-gray-100 pt-4">
            {member.linkedIn ? (
              <a
                href={member.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-indigo-100 bg-indigo-50 transition hover:border-indigo-300 hover:bg-indigo-100"
                aria-label={`${member.name} on LinkedIn`}
              >
                <img
                  src={IMAGES.iconLinkedIn}
                  alt=""
                  aria-hidden="true"
                  className="h-5 w-5 object-contain"
                />
              </a>
            ) : null}
          </div>
        </div>
      </article>
    </StaggerItem>
  );
}

function TeamSection() {
  return (
    <section
      id="team"
      className="relative z-10 w-full bg-stone-50 py-12 md:py-20"
      aria-label="Leadership team"
    >
      <div className="mx-auto flex w-full max-w-[1800px] flex-col gap-8 px-4 sm:px-6 md:gap-12 lg:px-10 xl:px-14 2xl:px-20">
        <Reveal className="flex flex-col items-center gap-2 text-center xl:items-start xl:text-left" variant="slideUp" animateOnMount>
          <div className="text-[1.15rem] font-semibold uppercase tracking-[0.2em] text-indigo-600 xl:text-[1.35rem]">
            {TEAM.eyebrow}
          </div>
          <h2 className="text-[1.575rem] font-extrabold leading-[1.25] tracking-tight text-indigo-950 sm:text-[1.8rem] md:text-[2.25rem] xl:text-[2.475rem] 2xl:text-[2.8125rem]">
            {TEAM.title}
          </h2>
        </Reveal>

        <StaggerGroup className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 xl:grid-cols-3">
          {TEAM.members.map((member, index) => (
            <TeamMemberCard key={member.id} member={member} index={index} />
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}

export default TeamSection;
